import { useEffect } from "react";

function App() {
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    const qs = new URLSearchParams(search);
    if (pathname.startsWith("/payment/success")) qs.set("payment", "success");
    else if (pathname.startsWith("/payment/cancel")) qs.set("payment", "cancel");
    const q = qs.toString();
    window.location.replace("/pagesforever.html" + (q ? `?${q}` : "") + hash);
  }, []);
  return null;
}

export default App;
